import { useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
// import LogoutContainer from "../Layout/LogoutContainer";
import { HeaderStyle } from "../Common/styles/header";
import { useAppSelector } from "../../Redux/hooks";
import { platformAdminPermissions } from "../../utils/roles";
import SitesList from "./SitesList";
import {
  a11yProps,
  CustomTabPanel2,
  StyledTab,
  StyledTabs,
} from "../Common/UI/TabPanel";
import RoomsList from "./RoomsList";
import { dataTablePageShell } from "../../utils/dataTableShell";

const AllSites = () => {
  const [selectedTab, setSelectedTab] = useState("sites");
  const platformPermissions = useAppSelector(
    (state) => state.user.platformPermissions
  );

  const canAdd = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.manageRegistry),
    [platformPermissions]
  );

  const handleTabsChange = (_: any, newValue: string) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          Locations and Rooms
        </Typography>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
        <StyledTabs value={selectedTab} onChange={handleTabsChange}>
          <StyledTab label="Location" value="sites" {...a11yProps(0)} />
          <StyledTab label="Rooms" value="rooms" {...a11yProps(1)} />
        </StyledTabs>
      </Box>
      <Box sx={{ p: 2.5, ...dataTablePageShell("calc(100% - 121px)") }}>
        <CustomTabPanel2 value={selectedTab} index={"sites"}>
          <SitesList canEdit={canAdd} />
        </CustomTabPanel2>
        <CustomTabPanel2 value={selectedTab} index={"rooms"}>
          <RoomsList canEdit={canAdd} />
        </CustomTabPanel2>
      </Box>
    </>
  );
};

export default AllSites;
